import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../core/services/auth/auth.service';
import { ReembolsoService } from '../../core/services/http/reembolso.service';
import { SweetAlertService } from '../../core/services/sweet-alert/sweet-alert.service';
import { ReporteriaService } from '../../core/services/http/reporteria/reporteria.service';
import { VentabonosService } from 'src/app/core/services/http/ventabonos.service';
import { BonogesService } from 'src/app/core/services/http/bonoges.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {
  img = 'assets/img/slider-home.png';
  title = '';
  excedentes = 0;
  perfilUsuario = '';
  cotizante = {};
  rutBeneficiario: number;
  itemMenu: string;
  gesActivo = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    private reembolsoService: ReembolsoService,
    private sweetAlertService: SweetAlertService,
    private reporteriaService: ReporteriaService,
    private ventabonosService: VentabonosService,
    private bonogesService: BonogesService
  ) { }

  ngOnInit() {
    this.consultarCotizante();
  }

  async consultarCotizante() {
    this.sweetAlertService.swalLoading();

    const data = await this.reembolsoService.getDatosCotizante();

    if (data['status']) {
      this.perfilUsuario = data['data']['codigoPerfil'].toString();
      this.cotizante = data['data'];
    }
    await this.getExcedentes();
    await this.getGesActivo();

    this.sweetAlertService.swalClose();
  }

  async getExcedentes() {
    const response = await this.ventabonosService.getExcedentes(this.cotizante['marca']);
    if (response['status']) {
      this.excedentes = response['data']['excedentes'];
    }
  }

  async getGesActivo() {
    const rutCotizante = this.getCotizante();
    const data = {
      rutCotizante,
      incluyeCotizante: true
    };

    const response = await this.bonogesService.getBeneficiarios(data);

    if (response['status']) {

      const beneficiario = response['data'].filter(ben => {
        return (ben.rutBen === rutCotizante) || (ben.rutBen === this.rutBeneficiario) || (ben.relacion.includes('HIJO'));
      });

      if (beneficiario.length) {
        this.gesActivo = beneficiario[0]['tieneGesActivo'];
      }
    }
  }

  getCotizante() {
    if (this.cotizante['tipoPerfil'] === 'BENEFICIARIO') {
      this.rutBeneficiario = this.cotizante['rutBeneficiario'];
      return this.cotizante['rutCotizante'];
    } else {
      return parseInt(localStorage.getItem('cbRutCliente'), 10);
    }
  }

  menu(e: any, action: string) {
    e.preventDefault();
    this.itemMenu = action;

    this.router.navigate([action]);
  }

  logout() {
    this.reporteUsabilidad('Cerrar sesión', 'Cierre de sesión de usuario', true);
    this.authService.logout();
  }

  reporteUsabilidad(recurso: string, respuesta: string, status: boolean) {
    const rut = localStorage.getItem('cbRutCliente') + '-' + localStorage.getItem('cbDigRut');
    this.reporteriaService.saveLog(
      'Menú',
      recurso,
      respuesta,
      'Front-End',
      status,
      rut
    );
  }
}
